import { useEffect, useState } from 'react';

export const useMediaQuery = (mediaQueryString: string): boolean | null => {
  const [queryMatch, setQueryMatch] = useState<boolean | null>(null);

  useEffect(() => {
    const setMediaMatchHandler = (e: MediaQueryListEvent) =>
      setQueryMatch(e.matches);

    const mediaQueryList: MediaQueryList = window.matchMedia(mediaQueryString);
    setQueryMatch(mediaQueryList.matches);
    mediaQueryList.addEventListener<'change'>('change', setMediaMatchHandler);

    return () => {
      mediaQueryList.removeEventListener<'change'>(
        'change',
        setMediaMatchHandler,
      );
    };
  }, [mediaQueryString]);

  return queryMatch;
};
